import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '../components/ui/card';
import { Mail } from 'lucide-react';

export const VerifyEmailPage: React.FC = () => {
  const navigate = useNavigate();

  const handleOpenGmail = () => {
    window.open('https://mail.google.com', '_blank');
  };

  const handleGoToLogin = () => {
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <div className="flex justify-center mb-4">
            <Mail className="h-16 w-16 text-primary" />
          </div>
          <CardTitle className="text-2xl">Verify Your Email</CardTitle>
          <CardDescription className="text-base mt-2">
            We've sent a verification link to your email address. Please check your inbox and click the link to verify your account.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button
            variant="outline"
            className="w-full"
            onClick={handleOpenGmail}
          >
            <Mail className="mr-2 h-4 w-4" />
            Open Gmail
          </Button>
          
          <div className="flex items-center gap-4">
            <div className="flex-1 h-px bg-border" />
            <span className="text-sm text-muted-foreground">then</span>
            <div className="flex-1 h-px bg-border" />
          </div>

          <Button
            className="w-full"
            onClick={handleGoToLogin}
          >
            Login
          </Button>
        </CardContent>
        <CardFooter>
          <p className="text-sm text-muted-foreground text-center w-full">
            After verifying your email, come back and log in to your account.
          </p>
        </CardFooter>
      </Card>
    </div>
  );
};


















